import { reduceToDigit } from './reduce.js';
/**
 * Life-path (destiny) number — sum the digits of YYYYMMDD, reduce.
 * Master numbers (11, 22, 33) are preserved at each reduction step.
 */
export function calcDestinyNumber(birthDate) {
    const digits = birthDate.replace(/\D/g, '');
    if (!digits)
        return 1;
    const sum = digits.split('').reduce((a, d) => a + parseInt(d, 10), 0);
    return reduceToDigit(sum);
}
//# sourceMappingURL=destiny.js.map